import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clothing3',
  templateUrl: './clothing3.component.html',
  styleUrls: ['./clothing3.component.scss']
})
export class Clothing3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
